import theme from '@styles/theme';
export default {
  accordionCmsContainer: {
    position: 'relative',
    width: '100%',
    padding: [theme.grids.container.padding.mobileBigMargin, theme.grids.container.padding.mobileBigMargin, theme.grids.container.padding.tabletSmallMargin, theme.grids.container.padding.tabletSmallMargin, theme.grids.container.padding.desktop],
    pt: ['40px', '40px', '64px', '64px', '88px'],
    pb: ['64px', '64px', '64px', '64px', '88px'],
    ...theme.grids.mainGrid
  },
  contentWrapper: {
    gridColumn: ['span 5', 'span 5', 'span 6', 'span 6', '2 / span 10'],
    borderTop: `1px solid ${theme.rawColors.lightGrey700}`
  },
  accordionContainer: {
    m: ['0', '0', '0', '0', '0 26px'],
    borderTop: `1px solid ${theme.rawColors.lightGrey700}`
  },
  accordionItem: {
    width: '100%',
    borderBottom: `1px solid ${theme.rawColors.lightGrey700}`
  },
  accordionHeader: {
    display: 'flex',
    p: ['20px 0', '20px 0', '20px 0', '24px 0', '24px 0', '27px 0'],
    '&:hover': {
      cursor: 'pointer'
    }
  },
  addButton: {
    ml: 'auto',
    pr: '10px'
  },
  accordionBlockContent: (isOpen: boolean) => ({
    m: ['4px 0 24px', '4px 0 24px', '12px 0 24px', '12px 0 24px', '16px 0 24px'],
    display: isOpen ? 'block' : 'none',
    height: isOpen ? 'auto' : 0,
    overflow: isOpen ? 'unset' : 'hidden',
    transition: 'height 0.3s ease-in-out'
  }),
  accordionContent: {
    '.cms-block__wysiwyg': {
      m: '16px 0'
    },
    '.cms-block__frame': {
      borderTop: `1px solid ${theme.rawColors.lightGrey300}`,
      p: '28px'
    }
  },
  newAccordionContainer: (bg: string) => ({
    bg,
    display: 'flex',
    flexDirection: 'column',
    p: ['64px 16px', '64px 16px', '80px 24px', '80px 24px', '6.0416667vw 10.15625vw '],
    position: 'relative'
  }),
  headerBlockWrapper: {
    width: '100%',
    ...theme.grids.mainGrid
  },
  headerBlockContent: {
    pb: ['24px', '24px', '32px', '32px', '40px'],
    p: {
      fontSize: [theme.fontSizes.caption, theme.fontSizes.text, theme.fontSizes.text, theme.fontSizes.text]
    }
  }
};